// Static configuration values for the Consistency drawer.
// Keep magic numbers, class strings and static labels here so the
// drawer/parts/columns files stay focused on rendering logic.

export const CONSISTENCY_DRAWER_WIDTH_CLS =
  "w-[1400px] max-w-[95vw]";

export const CONSISTENCY_TABLE_MAX_HEIGHT = "360px";
export const CONSISTENCY_TABLE_PAGE_SIZE = 5;

export const SEVERITY_PILL_BASE_CLS =
  "inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold";

export const CONSISTENCY_ITEM_LABELS = {
  terminology: "terms",
  references: "references",
  findings: "findings",
} as const;

export const CONSISTENCY_EMPTY_MESSAGES = {
  contradictions: "No internal contradictions detected.",
  definitionMismatches: "No definition mismatches detected.",
} as const;

export const CONSISTENCY_COPY = {
  title: "Consistency",
  description:
    "Internal contradictions, terminology drift and unresolved references identified within this document.",
  overallLabel: "Overall consistency",
  validatedLabel: "Validated",
  certifiedLabel: "Consistency · Certified",
  sourceEvidenceLabel: "View source evidence",
  loadingLabel: "Loading consistency...",
  sheetDescription:
    "Internal contradictions, terminology drift, definition mismatches and unresolved references detected in this document.",
} as const;

export const CONSISTENCY_SECTION_LABELS = {
  summary: {
    header: "Consistency summary",
    right: "Aggregated across the document",
  },
  highlight: {
    header: "Consistency highlight",
    right: "Signal summary",
  },
  contradictions: {
    header: "Internal contradictions",
    right: (n: number) => `${n} conflict pairs`,
  },
  terminology: {
    header: "Terminology drift",
    right: (n: number) => `${n} terms with variants`,
  },
  definitionMismatches: {
    header: "Definition mismatches",
    right: (n: number) => `${n} concepts affected`,
  },
  referenceGaps: {
    header: "Reference gaps",
    right: (n: number) => `${n} references reviewed`,
  },
  findings: {
    header: "Consistency findings",
    right: (n: number) => `${n} findings`,
  },
} as const;

export const CONSISTENCY_STAT_TONES = {
  statements: "cyan",
  contradictions: "amber",
  terminology: "indigo",
  references: "amber",
  score: "emerald",
} as const;
